import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class TimingEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    handleResolutionChange(r) {
        this.props.effect.resolution = r.value;
        this.setState(this.state);
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <div className="lfo-rate-dropdown">
                  <div className="lfo-rate-label">
                    Resolution:
                  </div>
                  <Dropdown
                    className='osc-type-dropdown'
                    controlClassName='osc-type-control-dropdown'
                    arrowClassName='osc-type-arrow-dropdown'
                    options={resolutionOptions}
                    onChange={(o) => this.handleResolutionChange(o)}
                    value={getResolutionOption(this.props.effect.resolution)}
                    placeholder="Rate" />
                    <div className="clear-fix"/>
                </div>
               <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                 root={2}
                  name={'Odd Timing Offset'}
                  parameter={this.props.effect.evenOffsetParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  automation={this.props.automation}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={-0.5}
                  max={4}/>
               <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Even Timing Offset'}
                 root={2}
                  parameter={this.props.effect.oddOffsetParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={-0.5}
                  max={4}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Probability'}
                  parameter={this.props.effect.probabilityParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0}
                  max={100}/>
              </ConditionedComponent>
            </div>
        );
    }
}

const resolutionOptions = [
    {value: 32.0, label:'1'},
    {value: 16.0, label:'1/2'},
    {value: 8.0, label:'1/4'},
    {value: 4.0 , label:'1/8'},
    {value: 2.0, label:'1/16'},
    {value: 1, label:'1/32'},
];

function getResolutionOption(value) {
    return resolutionOptions.filter(
        opt => opt.value === value)[0];
}


export default TimingEffectComponent;
